import { render, staticRenderFns } from "./InsightMenuIcon.vue?vue&type=template&id=52654d72&scoped=true"
import script from "./InsightMenuIcon.vue?vue&type=script&lang=ts"
export * from "./InsightMenuIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52654d72",
  null
  
)

export default component.exports